import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import React, { useEffect, useMemo, useState } from "react";
import { createContext, useContext } from "react";
var SEARCH_USING_THROTTLE_THRESHOLD = 1;
var SEARCH_SUGGESTIONS_THROTTLE_TIME_MS = 50;
var Context = /*#__PURE__*/ createContext("");
export var useSearchSuggestionsThrottledQueryString = function() {
    return useContext(Context);
};
export var SearchSuggestionsThrottledQueryStringProvider = function(param) {
    var children = param.children, searchValue = param.searchValue;
    var _useState = _sliced_to_array(useState(searchValue), 2), throttledSearchValue = _useState[0], setThrottledSearchValue = _useState[1];
    var updateThrottledSearchValue = useEffectEvent(function() {
        setThrottledSearchValue(searchValue);
    });
    var throttledUpdateThrottledSearchValue = useMemo(function() {
        return throttleIfPossible(updateThrottledSearchValue, SEARCH_SUGGESTIONS_THROTTLE_TIME_MS);
    }, [
        updateThrottledSearchValue
    ]);
    useEffect(function() {
        throttledUpdateThrottledSearchValue();
    }, [
        searchValue,
        throttledUpdateThrottledSearchValue
    ]);
    var value = searchValue.length >= SEARCH_USING_THROTTLE_THRESHOLD ? throttledSearchValue : searchValue;
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: value,
        children: children
    });
};
